<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="$route.meta.navbarClasses ? $route.meta.navbarClasses : 'bg-success navbar-dark'"
    type="info"
  >
<!--    <b-button-->
<!--      onclick="localStorage.id_token='eyJraWQiOiJJNjZzeWdPa09oT1ViallWeHdnQW1SWFUzRDJ3bHlVcGxGWlhvemtuVXRvPSIsImFsZyI6IlJTMjU2In0.eyJhdF9oYXNoIjoidVJSZk1zb1dNRk1oeUIyZm52NDR2ZyIsImN1c3RvbTpoYXZlQWNjb3VudCI6InRydWUiLCJzdWIiOiI1NWRiMzM4Mi0zMjhjLTQwZjgtOGNlMy03ZjkzY2E3MzY5OWUiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiY3VzdG9tOmhhdmVBY2NvdW50SW5zdGFncmFtIjoidHJ1ZSIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC5ldS13ZXN0LTEuYW1hem9uYXdzLmNvbVwvZXUtd2VzdC0xX0tUWWpUZE1BbyIsImNvZ25pdG86dXNlcm5hbWUiOiJicmFuY2hvZmFwcCIsImF1ZCI6IjIzaGJ2bnY5b2ZoZmo5MDNza29mNWpyZmdrIiwiY3VzdG9tOmVtYWlsX2xpbmtlZGluIjoiYnJhbmNob2ZhcHBAZ21haWwuY29tIiwiY3VzdG9tOmxhc3RXaXRoZHJhd1J1biI6IjE1NDg2Njg4OTgiLCJ0b2tlbl91c2UiOiJpZCIsImN1c3RvbTphdXRvbWF0ZWRZc3lBY3Rpb25zIjoid2l0aGRyYXdfdXNlcnNAWVNZQGxpa2VfcG9zdHNAWVNZQGVuZG9yc2VfdXNlcnMiLCJhdXRoX3RpbWUiOjE1OTUxODg1MjEsImN1c3RvbTpsYXN0RW5kb3JzZW1lbnRSdW4iOiIxNTc5OTgxMzA3IiwiY3VzdG9tOnJlZmVycmVyIjoiWVNZIiwiY3VzdG9tOmVtYWlsX2luc3RhZ3JhbSI6ImFtaW5lLmFpdGVsaGFycmFqQGdtYWlsLmNvbSxhbWluZS5haXRlbGhhcnJhakBnbWFpbC5jb20iLCJjdXN0b206aXNCbG9ja2VkIjoiZmFsc2UiLCJleHAiOjE1OTUxOTIxMjEsImN1c3RvbTpyb2xlIjoiYWRtaW4iLCJjdXN0b206bm90aWZ5WXN5QWN0aW9ucyI6Im5vdGlmeV93aXRoZHJhd191c2Vyc0BZU1lAbm90aWZ5X2VuZF9jb25maWd1cmF0aW9uIiwiaWF0IjoxNTk1MTg4NTIxLCJlbWFpbCI6ImJyYW5jaG9mYXBwQGdtYWlsLmNvbSJ9.bcIaPxI4nAWux6i7-I_94WV3f8ErJzL0-SUBTDhNwTYIWrFSUeI1rwWp8kBRAdDgeM-9-fQvPJ2Mxh9Ia2W-K-iBVYAHrHe4-7jZv8O6BahAKX1KRdTzH788HLtvAtb4L446DyKyuDTXyAlZsWMnb3vwrmjhaEM9xwwPuSdrIYoikDWqQ0pxRA-Ix93pv19WVCnU2uzEsAiafKkrQ7TI8a0zLS3O70FPFFvr-wleScSxb8yZy-tzDMoFBileZuAU8juQq-GGUxRkzaxbyzmVb9HF8Z2f9DfxSCvsC5AvFxIJ3IjYzySEv9LJ8GTqSqh-8Oofg9XsgK8I6GC6M3uSxA'">-->
<!--      unvalidate ysy tester-->
<!--    </b-button>-->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler sidenav-toggler-dark"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
      <li class="nav-item d-sm-none">
        <a class="nav-link" href="#" data-action="search-show" data-target="#navbar-search-main">
          <i class="ni ni-zoom-split-in"></i>
        </a>
      </li>
      <!--      <li>-->
      <!--        <button-->
      <!--          @click="breakIdToken">-->
      <!--          PRESS ME-->
      <!--        </button>-->
      <!--      </li>-->
    </ul>
  </base-nav>
</template>
<script>
    import {CollapseTransition} from 'vue2-transitions';
    import {BaseNav, Modal} from '../../components/Argon';

    export default {
        components: {
            CollapseTransition,
            BaseNav,
            Modal
        },
        computed: {
            routeName() {
                const {name} = this.$route;
                return this.capitalizeFirstLetter(name);
            },
            isRTL() {
                return this.$rtl.isRTL;
            }
        },
        data() {
            return {
                activeNotifications: false,
                showMenu: false,
                searchModalVisible: false,
                searchQuery: ''
            };
        },
        methods: {

            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            toggleNotificationDropDown() {
                this.activeNotifications = !this.activeNotifications;
            },
            closeDropDown() {
                this.activeNotifications = false;
            },
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
            hideSidebar() {
                this.$sidebar.displaySidebar(false);
            }
        }
    };
</script>
<style scoped>
  .top-navbar {
    top: 0px;
  }
</style>
